<template>
  <div class="main-wrapper">
    <div class="cart" v-show="cartTotalProduct > 0">
      <span class="cart-size" @click="showCart = !showCart"> {{ cartTotalProduct }} </span><i class="fa fa-shopping-cart" @click="showCart = !showCart"></i>
      <div class="cart-items scroll" v-show="showCart && cart.length">
        <table class="cartTable">
          <tbody>
            <tr class="product" v-for="(product, idx) in cart" :key="idx">
              <td class="align-left"><div class="cartImage" @click="removeProduct(product)" v-bind:style="{backgroundImage: getImageStyle(product.image)}" style="background-size: cover; background-position: center;"><i class="close fa fa-times"></i></div></td>
              <td class="align-center"><button @click="quantityChange(product, -1)"><i class="close fa fa-minus"></i></button></td>
              <td class="align-center">{{ cart[idx].quantity }}</td>
              <td class="align-center"><button @click="quantityChange(product, 1)"><i class="close fa fa-plus"></i></button></td>
              <td class="align-center">{{ product.title}}</td>
              <td>{{ product.price | currency }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="cart-action-cont" v-show="showCart && cart.length">
        <h4 class="cartSubTotal" v-show="showCart"> {{ cartSubTotal | currency }} </h4>
        <button class="clearCart" v-if="hasProduct" @click="clearCart"> Clear Cart </button>
        <button class="checkoutCart" v-if="hasProduct" @click="showCheckoutModal=true"> Checkout </button>
      </div>
    </div>
    <checkout-area v-if="hasProduct" :showModal="showCheckoutModal" :cart="cart" :cart-sub-total="cartSubTotal" :only-checkout="true" />
  </div>
  
</template>


<script>

  import Vue from 'vue';
  import {bus} from '../main';
  import common from '../common';

  import Checkout from './Checkout';

  var {api} = common;

  export default {
    name: 'Cart',
    components: {
      'checkout-area': Checkout,
    },
    data: function() {
      return {
        cart: [],
        showCart: false,
        showCheckoutModal: false,
      }
    },

    computed: {
      cartSubTotal: function() {
        let subTotal = 0;
        this.cart.forEach(product => {
          subTotal += (product.price * product.quantity);
        });
        return subTotal;
      },
      
      cartTotalProduct: function() {
        let cartTotalProduct = 0;
        this.cart.forEach(product => {
          cartTotalProduct += product.quantity;
        });
        return cartTotalProduct;
      },
      hasProduct: function(){
        return this.cart.length > 0;
      },
    },

    filters: {
      currency: function(price){
        return '$' + price;
      }
    },

    methods: {
      getImageStyle: function(img){
        img = img ? img.split(',')[0] : img;
        return "url(" + api + "uploads/" + img + ")";
      },
      removeProduct: function(product) {
        var idx = this.cart.indexOf(product);
        bus.$emit('prodRemove', idx);
      },
      clearCart: function() {
        bus.$emit('resetCart');
        this.showCart = false;
      },
      quantityChange: function(product, amount) {
        bus.$emit('quantChange', product, amount);
      },
    },

    created() {
      bus.$on('resetCart', () => {
        this.cart = [];
      });
      bus.$on('prodRemove', (idx) => {
        this.cart.splice(idx, 1);
      });
      bus.$on('addToCart', (product) => {
        let found;
        for (var i = 0; i < this.cart.length; i++) {
          if(this.cart[i].id === product.id) {
            let prev = {...this.cart[i]};
            prev.quantity++;
            Vue.set(this.cart, i, prev);
            found = true;
            break;
          }
        }
        if(!found) {
          product.quantity = 1;
          this.cart.push(product);
        }
      });
      bus.$on('quantChange', (product, amount) => {
        for (var i = 0; i < this.cart.length; i++) {
          if(this.cart[i].id === product.id) {
            let prev = {...this.cart[i]};
            if(prev.quantity <= 1 && amount < 0){
              this.cart.splice(i, 1);
              return;
            }
            prev.quantity += amount;
            Vue.set(this.cart, i, prev);
            break;
          }
        }
      });
      bus.$on('checkoutModalHide', () => {
        this.showCheckoutModal = false;
      });
    },

    mounted() {
      let cartData = localStorage && localStorage.getItem('cartData') ? JSON.parse(localStorage.cartData) : {cart: []};
      this.cart = cartData.cart;
    },

    watch: {
      cart: function(){
        let data = {
          cart: this.cart,
          cartSubTotal: this.cartSubTotal,
          cartTotalProduct: this.cartTotalProduct,
          hasProduct: this.hasProduct,
        };
        localStorage.setItem('cartData', JSON.stringify(data));
        bus.$emit('updateProdPage', data);
      }
    },
  }
</script>

<style scope>
  
</style>